import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 2,
  class: "flex flex-col"
}
const _hoisted_4 = { class: "overflow-x-auto" }
const _hoisted_5 = { class: "align-middle inline-block min-w-full" }
const _hoisted_6 = { class: "border overflow-hidden border-b border-gray-200 rounded-md" }
const _hoisted_7 = { class: "table-fixed min-w-full divide-y divide-gray-200" }
const _hoisted_8 = { class: "bg-gray-50" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-4 py-3 text-left text-xs font-medium text-gray-500 border-r"
}, " Contract ", -1)
const _hoisted_10 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_11 = { class: "px-2 py-3 whitespace-nowrap border-r" }
const _hoisted_12 = { class: "flex align-middle justify-between items-center" }
const _hoisted_13 = { class: "text-sm" }
const _hoisted_14 = { class: "px-2 py-1" }
const _hoisted_15 = {
  key: 0,
  class: "w-4 h-4"
}
const _hoisted_16 = {
  key: 1,
  style: {"margin-top":"-2px"}
}
const _hoisted_17 = {
  key: 0,
  class: "m-auto align-text-bottom rounded-full w-4 h-4 bg-red-200 border border-red-300 cursor-default text-red-600"
}
const _hoisted_18 = {
  key: 1,
  class: "m-auto align-text-bottom rounded-full w-4 h-4 bg-yellow-200 border border-yellow-300 cursor-default text-yellow-600 text-xs"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { style: {"line-height":"14px"} }, "?", -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 2,
  class: "m-auto align-text-bottom rounded-full w-4 h-4 bg-green-200 border border-green-300 cursor-default text-green-600"
}
const _hoisted_22 = {
  key: 3,
  class: "w-4 h-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XIcon = _resolveComponent("XIcon")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!

  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Loading "))
    : (_ctx.contracts.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " No contracts to show. "))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("table", _hoisted_7, [
                  _createElementVNode("thead", _hoisted_8, [
                    _createElementVNode("tr", null, [
                      _hoisted_9,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, (day, index) => {
                        return (_openBlock(), _createElementBlock("th", {
                          key: day.date,
                          class: _normalizeClass(["text-center text-xs font-medium text-gray-500 uppercase", _ctx.getDateBgClass(day)])
                        }, _toDisplayString(index + 1), 3))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("tbody", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contracts, (absenceReportContract) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: absenceReportContract.contract.id,
                        class: "hover:bg-gray-50"
                      }, [
                        _createElementVNode("td", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("span", _hoisted_13, [
                              _createElementVNode("span", _hoisted_14, _toDisplayString(absenceReportContract.contract.person.surname) + " " + _toDisplayString(absenceReportContract.contract.person.name), 1)
                            ])
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, (day, index) => {
                          return (_openBlock(), _createElementBlock("th", {
                            key: day.date,
                            class: _normalizeClass(_ctx.getDateBgClass(day))
                          }, [
                            ((day.holiday || day.weekend) && _ctx.isBlankDay(absenceReportContract.days[index]))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15))
                              : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                  (_ctx.isEmptyDay(absenceReportContract.days[index]))
                                    ? (_openBlock(), _createElementBlock("button", _hoisted_17, [
                                        _createVNode(_component_XIcon, {
                                          class: "h-3 w-3",
                                          style: {"margin-left":"1px"}
                                        })
                                      ]))
                                    : (_ctx.isPartialDay(absenceReportContract.days[index]))
                                      ? (_openBlock(), _createElementBlock("button", _hoisted_18, _hoisted_20))
                                      : (_ctx.isCompleteDay(absenceReportContract.days[index]))
                                        ? (_openBlock(), _createElementBlock("button", _hoisted_21, [
                                            _createVNode(_component_CheckIcon, {
                                              class: "h-3 w-3",
                                              style: {"margin-left":"1px"}
                                            })
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_22))
                                ]))
                          ], 2))
                        }), 128))
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ]))
}